import { MutationFn } from '@percent/education-hosted-form/hooks/useMutation/useMutation.types'
import { AgentVerificationResult, SubmitAgentVerificationFormProps } from './verifyAgent.types'

export const submitAgentVerification: MutationFn<SubmitAgentVerificationFormProps, AgentVerificationResult> = async (
  client,
  data
) => {
  const response = await client.post('v1/external-agent-verifications', data)

  return response.data
}
